<template>
  <div v-if="user.client">
    <edit-freeze-reason
      :isUndo="isUndo"
      :is-active.sync="undo"
      :user="user"
      :criminalCase.sync="currentCriminalCase"
      @edited="useUndo"
    />
    <edit-unfreeze-reason
      :is-active.sync="isUnfreezing"
      :criminalCase.sync="currentCriminalCase"
      :user="user"
      @edited="useFrozen"
    />
    <v-card>
      <slot name="title">
        <v-toolbar color="grey lighten-4" light tile flat>
          <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
      </slot>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items.sync="criminalCases"
          :items-per-page="10"
          class="elevation-0"
          :single-expand="false"
          show-expand
          :sort-by="[this.sortBy]"
          :sort-desc="[this.sortOrder == 'desc' ? true : false]"
          :expanded.sync="expanded"
        >
          <template slot="item.reference" slot-scope="{ item }">
            {{ item.reference }}
          </template>
          <template slot="item.first_name" slot-scope="{ item }">
            {{ item.first_name }}
          </template>
          <template slot="item.last_name" slot-scope="{ item }">
            {{ item.last_name }}
          </template>
          <template slot="item.alias_name" slot-scope="{ item }">
            {{ item.alias_name }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <strong>Percent Match:</strong> {{ item.pivot.percent_match }}
            </td>
          </template>
          <template slot="item.action" slot-scope="{ item }">
            <v-btn color="primary" @click="unfreezeOne(item)" v-if="item.pivot.is_flagged === 1">
              <v-icon>mdi-account-reactivate</v-icon> Unflag
            </v-btn>
            <v-btn @click="undoOne(item)" color="primary" v-if="item.pivot.is_flagged === 0">
              <v-icon>mdi-arrow-u-left-top</v-icon> Undo
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import EditFreezeReason from "./editFreezeReason.vue";
import EditUnfreezeReason from "./editUnfreezeReason.vue";

export default {
  components: {
    EditUnfreezeReason,
    EditFreezeReason,
  },
  props: {
    user: { required: true, type: Object },
    title: { default: "Asset Frozen status" },
    sortBy: { default: "date" },
    sortOrder: { default: "desc" },
  },
  data() {
    return {
      wasUnfrozen: false,
      undo: false,
      isUnfreezing: false,
      clients: [this.user.client],
      criminalCases: this.user.client.criminal_cases,
      expanded: [],
      currentCriminalCase: this.user.client.criminal_cases[0],
      isUndo: true,
      headers: [
        {
          text: "Reference",
          align: "start",
          sortable: true,
          value: "reference",
        },
        {
          text: "First Name",
          align: "start",
          sortable: true,
          value: "first_name",
        },
        { text: "Last Name", value: "last_name" },
        { text: "Alias", value: "alias_name" },
        { text: "", value: "data-table-expand" },
        { text: "Action", value: "action" },
      ],
    };
  },
  methods: {
    useFrozen({ user }) {
      this.isUnfreezing = false;
      this.$emit("update:user", user);
      Notify.success("User was updated successfully");
    },
    useUndo({ user }) {
      this.undo = false;
      this.$emit("update:user", user);
      Notify.success("User was updated successfully");
    },
    unfreezeOne(criminalCase) {
      this.isUnfreezing = true;
      this.currentCriminalCase = criminalCase;
    },
    undoOne(criminalCase) {
      this.undo = true;
      this.currentCriminalCase = criminalCase;
    },
  },
};
</script>
